import { chakra, Button as CkButton, Text as CkText } from '@chakra-ui/react'
import { EZIndexLayer } from 'enums/theme'
import L from 'leaflet'
export const BackButton = chakra(CkButton, {
  baseStyle: () => ({
    position: 'absolute',
    top: '6',
    left: '6',
    border: 'solid 1px',
    borderColor: 'background.grey.200',
    background: '#fff',
    display: { base: 'flex', lg: 'none' },
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: EZIndexLayer.CONTENT_VIEW
  })
})

export const BackButtonText = chakra(CkText, {
  baseStyle: () => ({
    color: 'text.grey.700',
    fontSize: 'lg',
    fontFamily: 'Inter',
    fontWeight: 600,
    marginLeft: '10px'
  })
})

export const createClusterCustomIcon = function (cluster: any): any {
  return L.divIcon({
    html: `<span><svg width="46" height="59" viewBox="0 0 46 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd_5519_21014)">
    <ellipse cx="23" cy="22.4" rx="20" ry="20.4" fill="#242E2E"/>
    <ellipse cx="23" cy="22.4001" rx="15" ry="15.3" fill="#E6FFFA"/>
    </g>
    <defs>
    <filter id="filter0_dd_5519_21014" x="0" y="0" width="46" height="58.0625" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5519_21014"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="1.5"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="effect1_dropShadow_5519_21014" result="effect2_dropShadow_5519_21014"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5519_21014" result="shape"/>
    </filter>
    </defs>
    </svg>
    <p>${cluster.getChildCount()}</p>
    </span>`,
    className: 'marker-cluster-custom',
    iconSize: L.point(40, 51, false)
  })
}
